// AppPortfolio.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function AppPortfolio() {
  return (
    <div>
      {/* Hero / Header Section */}
      <div className="home-container">
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1
                className="head text-center text-white animate__animated animate__zoomIn allHeaderP"
              >
                Mobile Apps Portfolio
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Portfolio Section */}
      <section
        className="clients-portfolio-section mt-4"
        style={{ backgroundColor: "#f1f3fe" }}
      >
        <div className="container mt-4">
          <div className="section-title mb-2 text-center">
            <h2>Mobile Apps Projects</h2>
            <h3>
              Our Portfolio Of <span>Android & iOS Applications</span>
            </h3>
            <p className="mt-0">
              Discover our extensive portfolio of mobile applications developed for both Android and iOS platforms. Our apps are designed to provide seamless user experiences, innovative features, and robust performance. From productivity tools to entertainment apps, explore how we bring ideas to life through cutting-edge mobile technology.
            </p>
          </div>

          <div className="container">
            {/* Row 1 */}
            <div className="row mt-4">
              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/happy-stack-tower" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/happy-stack-tower-home-screen.webp"
                      alt="Happy Stack Tower Game by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Happy Stack Tower
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/wallnex" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/wallnex-hd-wallpapers-category-list.webp"
                      alt="WallNex - HD Wallpapers App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    WallNex - HD Wallpapers
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/scan2pdf" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/scan2pdf-document-scan-screen-technicmentors.webp"
                      alt="Scan2PDF - Document Scanner by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Scan2PDF - Document Scanner
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/convert-units" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/convert-units-conversion-result-technicmentors.webp"
                      alt="Convert Units App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Convert Units
                  </h2>
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="row mt-4">
              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/tafheem-audio" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/tafheem-audio-offline-download-technicmentors.webp"
                      alt="Tafheem Audio Quran App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Tafheem Audio
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/maududi-books" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/maududi-books-library-home-technicmentors.png"
                      alt="Maududi Books Collection App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Maududi Books Collection
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/tourist-guide" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/tourist-guide-attractions-list-technicmentors.jpg"
                      alt="Tourist Guide App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Tourist Guide
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/warrenty-app" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/warranty-app-add-product-technicmentors.jpg"
                      alt="Warranty App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Warranty App
                  </h2>
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="row mt-4">
              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/capobrain" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/capobrain-fees-management-technicmentors.jpg"
                      alt="CapoBrain App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    CapoBrain
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/capobiz" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/capobiz-erp-dashboard-technicmentors.jpg"
                    
                      alt="CapoBiz App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    CapoBiz
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/little-genious" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/little-genius-brain-games-technicmentors.jpg"
                      alt="Little Genious App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Little Genious
                  </h2>
                </div>
              </div>

              <div className="col-6 col-md-3 mb-4">
                <Link to="/app/kids-learning" style={{ textDecoration: 'none' }}>
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '12px',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      aspectRatio: '9 / 16',
                      width: '100%',
                      backgroundColor: '#f8f9fa',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                    }}
                  >
                    <img
                      src="assets/img/app portfolio/brainy-kids-games-screen-technicmentors.jpg"
                      alt="Kids Learning App by Technic Mentors"
                      style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        display: 'block',
                      }}
                    />
                  </div>
                </Link>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }}>
                    Kids Learning
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>

     
      </section>
    </div>
  );
}